import IconLogoLight from "~/assets/imgs/logo-svg-light.svg";
import IconLogoDark from "~/assets/imgs/logo-svg-dark.svg";

import { themeParams, useSignal } from "@telegram-apps/sdk-react";

export default function InitLoading({ style = {} as React.CSSProperties }) {
    const isDark = useSignal(themeParams.isDark);

    return (
        <div className="bg-bg_0">
            <div
                style={style}
                className="w-full h-[100vh] flex justify-center items-center"
            >
                {isDark ? (
                    <img
                        className="w-[160px]"
                        alt="loading logo dark"
                        src={IconLogoDark}
                    />
                ) : (
                    <img
                        className="w-[160px]"
                        alt="loading logo light"
                        src={IconLogoLight}
                    />
                )}
            </div>
        </div>
    );
}
